import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { initHandleOperation } from '@4r/module-common-ant-components';
import 'antd/dist/antd.less';
import '@4r/ant-theme-config/dist/index.css';
import './index.scss';
import './toast.scss';
import './index.css';
import './typographyOverrides.scss';
import App from './pages/App';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import BASE_PATH from './common/base-path';
import loadSettings from './common/loadSettings';
import { initObservability } from './observability/faro';
import { TelemetryEvent, trackEvent } from './observability/telemetry';

initHandleOperation();

function render() {
	ReactDOM.render(
		<Router basename={BASE_PATH}>
			<App />
		</Router>,
		document.getElementById('root'),
	);
}

// Observability is initialised before the first render so that failures during app bootstrap
// — the micro-frontend bundle loading, the Google Maps script injection, the auth handshake —
// are reported. App renders nothing until settings resolve anyway, so waiting here costs no
// visible time. If config.json cannot be loaded the app is not functional regardless; render
// so the existing (blank) behaviour is preserved instead of silently hanging on a rejection.
loadSettings()
	.then((settings) => initObservability(settings))
	.catch((e) => {
		// eslint-disable-next-line no-console
		console.error('index: failed to load settings, starting without observability', e);
	})
	.finally(() => {
		render();

		// These hooks existed but were never wired up. They answer "how many installs are still
		// running an old build", which recurs every time an offline fix ships and cannot be
		// answered from app.version alone (a stale SW keeps serving the old bundle).
		serviceWorkerRegistration.register({
			onSuccess: () => trackEvent(TelemetryEvent.ServiceWorkerInstalled),
			onUpdate: () => trackEvent(TelemetryEvent.ServiceWorkerUpdated),
		});
	});
